import { Table } from 'components/Table';
import {
  ControlWrapper,
  Header,
  HeaderContainer,
  ControlLabel,
  Controls,
  TableWrapper,
} from './PerformanceReturnsStyles';
import { Select } from 'components/Select';
import { usePerformanceReturnsData } from './usePerformanceReturnsData';
import { DatePicker } from 'components/DatePicker';
import { Stream } from 'types/PerformanceReturns';
import { Button } from 'components/Button';
import Refresh from 'components/Icons/Refresh';

type Props = {
  benchmarkId?: string;
  onDrillDown?: (
    date: string,
    stream?: Stream | null,
    streamCompare?: Stream | null
  ) => void;
};

export const PerformanceReturns = ({ benchmarkId, onDrillDown }: Props) => {
  const drillDownHandler = (date: string) => {
    onDrillDown?.(date, stream, streamCompare);
  };

  const {
    isLoading,
    streams,
    frequencies,
    startDate,
    startDateHandler,
    endDate,
    endDateHandler,
    calcFrequency,
    calcFrequencyHandler,
    stream,
    setStream,
    streamCompare,
    setStreamCompare,
    tableData,
    tableColumns,
    resetFilters,
  } = usePerformanceReturnsData({ benchmarkId, drillDownHandler });

  function streamChangeHandler(data: Stream) {
    // TODO: For  mock data purposes. Delete next line and uncomment `setStream(data);`;
    setStream({ ...data, streamId: '1' });
    // setStream(data);
  }

  function streamCompareHandler(data: Stream) {
    // TODO: For  mock data purposes. Delete next line and uncomment `setStreamCompare(data);`;
    setStreamCompare({ ...data, streamId: '2' });
    // setStreamCompare(data);
  }

  return (
    <>
      <HeaderContainer>
        <Header>Performance Returns</Header>
        <Controls>
          <ControlWrapper>
            <ControlLabel>Created</ControlLabel>
            <Select
              value={stream}
              options={streams}
              onChange={streamChangeHandler}
              style={{ width: 220 }}
            />
          </ControlWrapper>
          <ControlWrapper>
            <ControlLabel>Frequency</ControlLabel>
            <Select
              value={calcFrequency}
              options={frequencies}
              onChange={calcFrequencyHandler}
            />
          </ControlWrapper>
          <ControlWrapper>
            <ControlLabel>Start Date</ControlLabel>
            <DatePicker
              onChange={startDateHandler}
              selected={startDate}
              testid='start-date-picker'
            />
          </ControlWrapper>
          <ControlWrapper>
            <ControlLabel>End Date</ControlLabel>
            <DatePicker
              onChange={endDateHandler}
              selected={endDate}
              testid='start-date-picker'
            />
          </ControlWrapper>
          <ControlWrapper>
            <ControlLabel>Compare to Historical Data</ControlLabel>
            <Select
              value={streamCompare}
              options={streams}
              onChange={streamCompareHandler}
              style={{ width: 220 }}
            />
          </ControlWrapper>
          {stream || calcFrequency || startDate || endDate || streamCompare ? (
            <Button
              variant='tertiary'
              data-testid='benchmarks-reset-table'
              onClick={resetFilters}
            >
              <Refresh
                style={{
                  marginRight: 2,
                  marginTop: 2,
                }}
              />
              Reset Filters
            </Button>
          ) : null}
        </Controls>
      </HeaderContainer>

      {tableColumns ? (
        <TableWrapper
          style={{ maxWidth: tableColumns.length === 2 ? 400 : '100%' }}
        >
          <Table
            data={tableData ?? []}
            columns={tableColumns}
            isLoading={isLoading}
          />
        </TableWrapper>
      ) : null}
    </>
  );
};
